<template>
    <form action="">
        <div class="modal-card" style="width: auto; margin-right: 100px; margin-left: 100px">
            <header class="modal-card-head">
                <p class="modal-card-title">Account invitation link for {{ inviteName }}</p>
            </header>
            <section class="modal-card-body">
                <b-field>
                    <b-input :id="'invite-link-' + inviteId"
                             :value="inviteLink"
                             v-on:focus="selectShareLink"
                             @icon-click="copyLink"
                             icon="clipboard"
                             icon-clickable>
                    </b-input>
                </b-field>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$parent.close()">Close</button>
                <b-button
                        class="has-icon"
                        icon-left="clipboard"
                        type="is-info"
                        label="Copy Link"
                        v-on:click.prevent="copyLink" />
            </footer>
        </div>
    </form>
</template>
<script>
import { mapActions } from 'vuex'
import copy from 'copy-to-clipboard'

export default {
  name: 'AccountInviteModal',
  props: ['inviteLink', 'inviteName', 'inviteId', 'inviteEmail'],
  methods: {
    ...mapActions([
      'notifyInvite'
    ]),
    handleError (err) {
      if (err.hasOwnProperty('response')) {
        if (err.response.status === 404 || err.response.status === 403) {
          // going back to many times
          this.$router.push('/accounts')
          this.$emit('modal-close')
        }

        if (err.response.data.response === 'error') {
          this.$awn.warning(err.response.data.message)
        }
      } else {
        this.$awn.alert(err.toString())
      }
    },
    copyLink () {
      copy(this.inviteLink)
      this.$awn.success('Invitation link copied to clipboard!')
    },
    selectShareLink () {
      document.getElementById('invite-link-' + this.inviteId).select()
    }
  },
  mounted () {
    // Move modal inside of #app
    let el = document.getElementsByClassName('modal is-active')[0]
    let container = document.getElementById('app')
    if (container) {
      (container.firstChild)
        ? container.insertBefore(el, container.firstChild)
        : container.appendChild(el)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Promps/InviteLink.vue